__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@ads-center/shell";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ads-center/env", "1.0.0", function() { return function() { return __webpack_require__(1446); }; }, 1);
			register("@ads-center/store", "3.0.0", function() { return Promise.all([__webpack_require__.e(392), __webpack_require__.e(451), __webpack_require__.e(213), __webpack_require__.e(5), __webpack_require__.e(788)]).then(function() { return function() { return __webpack_require__(1577); }; }); });
			register("@p1/constants", "1.2.0", function() { return function() { return __webpack_require__(9259); }; }, 1);
			register("@p1/i18n", "1.0.0", function() { return function() { return __webpack_require__(6826); }; }, 1);
			register("@p1/services", "1.0.0", function() { return Promise.all([__webpack_require__.e(392), __webpack_require__.e(596)]).then(function() { return function() { return __webpack_require__(3023); }; }); });
			register("@p1/ui-common", "2.2.0", function() { return Promise.all([__webpack_require__.e(178), __webpack_require__.e(95), __webpack_require__.e(451), __webpack_require__.e(426), __webpack_require__.e(51), __webpack_require__.e(682)]).then(function() { return function() { return __webpack_require__(6051); }; }); });
			register("antd", "5.0.2", function() { return Promise.all([__webpack_require__.e(178), __webpack_require__.e(785), __webpack_require__.e(95), __webpack_require__.e(139), __webpack_require__.e(863)]).then(function() { return function() { return __webpack_require__(2785); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(366), __webpack_require__.e(95)]).then(function() { return function() { return __webpack_require__(4366); }; }); });
			register("react-router-dom", "6.4.3", function() { return Promise.all([__webpack_require__.e(196), __webpack_require__.e(95), __webpack_require__.e(137)]).then(function() { return function() { return __webpack_require__(8196); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(410).then(function() { return function() { return __webpack_require__(410); }; }); });
			register("recoil", "0.7.6", function() { return Promise.all([__webpack_require__.e(261), __webpack_require__.e(95), __webpack_require__.e(139), __webpack_require__.e(822)]).then(function() { return function() { return __webpack_require__(2261); }; }); });
			register("recoil", "0.7.6", function() { return Promise.all([__webpack_require__.e(418), __webpack_require__.e(95), __webpack_require__.e(139), __webpack_require__.e(995)]).then(function() { return function() { return __webpack_require__(2418); }; }); });
			initExternal(6015);
			initExternal(9886);
			initExternal(2138);
			initExternal(5266);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};